"use client"

import Link from "@/components/ui/link"
import { Menu } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Sheet, SheetTrigger, SheetContent, SheetTitle } from "@/components/ui/sheet"
import { VisuallyHidden } from "@/components/ui/visually-hidden"
import { Suspense } from "react"
import { Logo } from "./logo"
import { UserMenu } from "./user-menu"
import { SidebarContent } from "./sidebar"
import { LoadingSpinner } from "./loading-spinner"
import { NotificationCenter } from "@/components/shared/notification-center"
import { CommandPaletteTrigger } from "@/components/shared/command-palette-trigger"
import { useHasMounted } from "@/hooks/use-has-mounted"

export function Header() {
  const hasMounted = useHasMounted()

  return (
    // Full-bleed rather than a centred container: the logo has to sit over the
    // sidebar column, and a `container` inside a full-width bar meant nothing
    // in the header lined up with anything below it.
    <header className="border-b border-border/40">
      <div className="flex h-14 md:h-16 items-center gap-4 px-4 md:px-6">
        <div className="flex items-center gap-2 shrink-0 md:gap-3">
          {hasMounted ? (
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="md:hidden">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent id="mobile-nav-sheet-content" side="left" className="w-64 p-0 pt-12">
                <VisuallyHidden>
                  <SheetTitle>Navigation Menu</SheetTitle>
                </VisuallyHidden>
                <Suspense fallback={<LoadingSpinner />}>
                  <SidebarContent idPrefix="mobile-sidebar" />
                </Suspense>
              </SheetContent>
            </Sheet>
          ) : (
            <Button variant="ghost" size="icon" className="md:hidden" aria-hidden="true" tabIndex={-1}>
              <Menu className="h-5 w-5" />
            </Button>
          )}
          <Link href="/" className="flex items-center gap-2">
            <Logo />
          </Link>
        </div>
        <div className="flex-1 flex justify-center">
          <CommandPaletteTrigger />
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {hasMounted ? (
            <>
              <NotificationCenter />
              <UserMenu />
            </>
          ) : (
            <>
              <Button variant="ghost" size="icon" className="relative h-9 w-9" aria-hidden="true" tabIndex={-1}>
                <span className="sr-only">Notifications</span>
              </Button>
              <Button variant="ghost" size="icon" className="rounded-full" aria-hidden="true" tabIndex={-1}>
                <span className="sr-only">User menu</span>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
